import { render, staticRenderFns } from "./chat-room-view-messages.vue?vue&type=template&id=1365498f"
import script from "./chat-room-view-messages.vue?vue&type=script&lang=js"
export * from "./chat-room-view-messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports